import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { t } from "../../translations";

import "../styles/section-food-list.css";

import { BsShareFill } from "react-icons/bs";

import { AiFillHeart, AiFillStar } from "react-icons/ai";

import { FaCheck, FaCopy, FaUserCircle } from "react-icons/fa";

import { MdDeliveryDining, MdInsertComment } from "react-icons/md";

import { GrValidate } from "react-icons/gr";

import { CircularProgress, Dialog, DialogContent } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import EmptyCart from "../../assets/empty-cart.png";
import {
  POST_PREFERRED,
  POST_TO_CART,
  TOGGLE_DIALOG
} from "../../store/action";
import { getSafeOrigin } from "../../utils/capacitorSafety";
import { createLogger } from "../../utils/logger";
import { POST, UPDATE } from "../constants/request-type";
import { service_api } from "../constants/url";
import { Aa } from "../functions/Aa";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import FoodView from "./food-view";

// Ionic imports for mobile
import {
  IonAvatar,
  IonBadge,
  IonButton,
  IonCard, IonCardContent,
  IonChip,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonSpinner,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import { heart, heartOutline, person, personOutline, shareOutline, star } from "ionicons/icons";
import { hapticPatterns } from "../../utils/haptics";
import { shouldUseIonicComponents } from "../../utils/platformUtils";
import { shareChef } from "../../utils/sharing";

const logger = createLogger("SectionFoodList");
const SectionFoodList = (props) => {
  const useMobileUI = shouldUseIonicComponents();
  
  let cart = useSelector((state) => state.cart);
  let selectedWhen = useSelector((state) => state.selectedWhen);
  let selectedChef = useSelector((state) => state.selectedChef);
  let preferred = useSelector((state) => state.preferred);
  let user = useSelector((state) => state.user);
  const history = useHistory();

  const [shareMenu, openShareMenu] = useState(false);
  const [referralLink, setReferralLink] = useState("");
  const [copied, setCopied] = useState(false);

  let { searched, list, lang, whichChef, reviewList, blogList } = props;

  const [currentDate, setCurrentDate] = useState("");

  const [loading, setLoading] = useState(false);
  const [favoriteLoading, setFavoriteLoading] = useState(false);

  useEffect(() => {
    if (!selectedWhen) {
      setCurrentDate("");
      return;
    }

    const options = {
      day: "2-digit",
      month: "long",
      year: "numeric",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };

    // Parse the date string properly to avoid timezone issues
    // If selectedWhen is "2026-01-17", we want to display January 17, 2026
    let dateToFormat;
    if (typeof selectedWhen === "string") {
      // Parse as YYYY-MM-DD format and treat as local date
      const [year, month, day] = selectedWhen.split("-");
      dateToFormat = new Date(
        parseInt(year),
        parseInt(month) - 1,
        parseInt(day)
      );
    } else {
      dateToFormat = new Date(selectedWhen);
    }

    const formattedDate = dateToFormat.toLocaleDateString(undefined, options);
    setCurrentDate(formattedDate);

    logger.log("selectedWhen:", selectedWhen);
    logger.log("formattedDate:", formattedDate);
  }, [selectedWhen]);

  // Track share when arriving via referral link
  useEffect(() => {
    const trackShareOnArrival = async () => {
      // Get URL parameters safely
      let urlParams;
      try {
        if (typeof window !== "undefined" && window.location) {
          urlParams = new URLSearchParams(window.location.search);
        } else {
          return; // Exit if window.location not available
        }
      } catch (e) {
        return; // Exit on error
      }

      const ref = urlParams.get("ref");
      const foodId = urlParams.get("food");
      const chefId = urlParams.get("chef");

      // Only track if referral code exists
      if (!ref || !chefId) return;

      try {
        if (foodId) {
          // Track food share
          const request_details = {
            type: POST,
            url: service_api,
            route: `user/track-food-share`,
            data: {
              food_id: foodId,
              chef_id: chefId,
              user_id: user?._id || null,
              referral_code: ref,
              platform: "web"
            },
            token: user?.refresh_token || null
          };
          await MakeRequestAsync(request_details);
          logger.log("Food share arrival tracked successfully");
        } else {
          // Track chef profile share
          const request_details = {
            type: POST,
            url: service_api,
            route: `user/track-chef-share`,
            data: {
              chef_id: chefId,
              user_id: user?._id || null,
              referral_code: ref,
              platform: "web"
            },
            token: user?.refresh_token || null
          };
          await MakeRequestAsync(request_details);
          logger.log("Chef profile share arrival tracked successfully");
        }
      } catch (err) {
        logger.error(
          "Failed to track share arrival:",
          err?.response?.data?.message
        );
      }
    };

    trackShareOnArrival();
  }, [selectedChef?._id, user?._id, user?.refresh_token]);

  const dispatch = useDispatch();

  const post_to_cart = (data) => {
    dispatch(post_cart(data));
  };

  const setPreferred = (value) => dispatch(post_preferred(value));

  const openDialog = (value) => dispatch(toggle_dialog(value));

  const followChef = async () => {
    await hapticPatterns.buttonClick();
    
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: `user/chef-followers?chef_id=${selectedChef?._id}&follower=${user._id}`,
      token: user?.refresh_token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      // setLoad(false);
      const decryptedData = decryptSingleData(response.data.user);
      whichChef(decryptedData);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    }
  };

  const toggleFavorite = async () => {
    await hapticPatterns.buttonClick();
    
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: `user/chef-favorites?chef_id=${selectedChef?._id}&user_id=${user._id}`,
      token: user?.refresh_token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      const decryptedData = decryptSingleData(response.data.user);

      // Update local preferred state for UI consistency
      if (decryptedData.isFavorited) {
        setPreferred([...preferred, selectedChef?._id]);
      } else {
        setPreferred([
          ...preferred?.filter((data) => data !== selectedChef?._id)
        ]);
      }

      // Update chef data with new counts
      whichChef(decryptedData);
      setFavoriteLoading(false);
    } catch (err) {
      setFavoriteLoading(false);
      logger.log("We couldn't toggle favorite: ", err?.response?.data?.message);
    }
  };

  const handleShare = async () => {
    await hapticPatterns.buttonClick();
    const shared = await shareChef(selectedChef);
    if (!shared) {
      // Fallback to dialog - handled by shareChef utility
      const userId = user?._id || "guest";
      const chefId = selectedChef?._id;
      const baseUrl = getSafeOrigin();
      const link = `${baseUrl}/order/chef/menu?chef=${chefId}&ref=${userId}`;
      setReferralLink(link);
      setCopied(false);
      openShareMenu(true);
    }
  };

  // Calculate rating
  const rating = reviewList.length === 0
    ? 0
    : (reviewList?.reduce((a, b) => a + b?.rate_food.rate, 0) / reviewList.length);

  // Mobile version
  if (useMobileUI) {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonTitle>
              {t("section_food_list.chef", lang, user?.restaurant)}{" "}
              {Aa(selectedChef?.firstname) + " " + Aa(selectedChef?.lastname)}
            </IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          {/* Chef Header Card */}
          <IonCard>
            <img 
              src={selectedChef?.preview} 
              alt="chef-preview"
              style={{ width: '100%', height: '200px', objectFit: 'cover' }}
            />
            <IonCardContent>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                <IonAvatar style={{ width: '80px', height: '80px' }}>
                  <img src={selectedChef?.pic1} alt={selectedChef?.firstname} />
                </IonAvatar>
                <div style={{ flex: 1 }}>
                  <h2 style={{ margin: '0 0 8px 0' }}>
                    {t("section_food_list.chef", lang, user?.restaurant)}{" "}
                    {Aa(selectedChef?.firstname) + " " + Aa(selectedChef?.lastname)}
                  </h2>
                  <p style={{ margin: '0 0 8px 0', color: '#666' }}>
                    {t("section_food_list.native_from", lang)} {selectedChef?.country}
                  </p>
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    {selectedChef?.speciality_tag?.map((tag, i) => (
                      <IonChip key={tag?._id || i} color="primary" style={{ fontSize: '12px' }}>
                        {typeof tag === "string" ? tag : (lang === "fr" ? tag?.name : tag?.eng_name) || tag?.name}
                      </IonChip>
                    ))}
                  </div>
                </div>
              </div>
              
              {/* Action buttons */}
              <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                <IonButton 
                  expand="block" 
                  fill={selectedChef?.isFavorited ? "solid" : "outline"}
                  color="danger"
                  onClick={() => {
                    if (user === null) {
                      return openDialog(true);
                    }
                    if (favoriteLoading) {
                      return;
                    }
                    setFavoriteLoading(true);
                    toggleFavorite();
                  }}
                  disabled={favoriteLoading}
                  style={{ flex: 1 }}
                >
                  {favoriteLoading ? (
                    <IonSpinner name="crescent" />
                  ) : (
                    <>
                      <IonIcon icon={selectedChef?.isFavorited ? heart : heartOutline} slot="start" />
                      {t("section_food_list.favorite", lang)} ({selectedChef?.favoriteCount || 0})
                    </>
                  )}
                </IonButton>
                
                <IonButton 
                  expand="block"
                  fill={selectedChef?.isFollowing ? "solid" : "outline"}
                  color="primary"
                  onClick={() => {
                    if (user === null) {
                      return openDialog(true);
                    }
                    if (loading) {
                      return;
                    }
                    setLoading(true);
                    followChef();
                  }}
                  disabled={loading}
                  style={{ flex: 1 }}
                >
                  {loading ? (
                    <IonSpinner name="crescent" />
                  ) : (
                    <>
                      <IonIcon icon={selectedChef?.isFollowing ? person : personOutline} slot="start" />
                      {t("section_food_list.follow", lang)} ({selectedChef?.followerCount || 0})
                    </>
                  )}
                </IonButton>
                
                <IonButton
                  fill="clear"
                  onClick={handleShare}
                >
                  <IonIcon icon={shareOutline} slot="icon-only" />
                </IonButton>
              </div>
              
              {/* Stats */}
              <div style={{ display: 'flex', justifyContent: 'space-around', paddingTop: '16px', borderTop: '1px solid #eee' }}>
                <div style={{ textAlign: 'center' }}>
                  <IonBadge color="warning">
                    <IonIcon icon={star} style={{ marginRight: '4px' }} />
                    {rating > 0 ? rating.toFixed(2) : t("section_food_list.na", lang)}
                  </IonBadge>
                  <div style={{ fontSize: '12px', marginTop: '4px' }}>{t("common.rating", lang)}</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <IonBadge color="medium">{reviewList.length}</IonBadge>
                  <div style={{ fontSize: '12px', marginTop: '4px' }}>{t("section_food_list.comments", lang)}</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <IonBadge color="success">
                    {reviewList?.filter((item) => item.status === 3)?.length}
                  </IonBadge>
                  <div style={{ fontSize: '12px', marginTop: '4px' }}>{t("section_food_list.deliveries", lang)}</div>
                </div>
              </div>
              
              {selectedChef?.certificate_safety?.pic && (
                <div style={{ marginTop: '16px', padding: '12px', backgroundColor: '#227F21', color: 'white', borderRadius: '8px', textAlign: 'center' }}>
                  <IonIcon icon={star} /> {t("section_food_list.food_hygiene_certified", lang)}
                </div>
              )}
            </IonCardContent>
          </IonCard>
          
          {/* Food List - reuse existing FoodView component */}
          <FoodView
            foodList={list
              ?.filter((item) => {
                return item?.chef_id === selectedChef?._id;
              })
              ?.filter((item) => {
                if (searched.length > 0) {
                  return item?.name
                    ?.toLowerCase()
                    .includes(searched.toLowerCase());
                }
                return item;
              })}
            reviewList={reviewList}
            blogList={blogList}
          />
        </IonContent>
      </IonPage>
    );
  }

  return (
    <div className="section-food-list">
      <div className="section-food-list-block">
        <div className="section-food-list-left">
          <img alt="chef-preview" src={selectedChef?.preview} />
          <div className="section-food-profile-block">
            <div className="section-food-profile-left">
              <img
                alt="img-profile"
                src={selectedChef?.pic1}
                style={{
                  width: 150,
                  height: 150,
                  borderRadius: "50%",
                  backgroundColor: "#fff",
                  objectFit: "cover",
                  border: "4px solid #fff"
                }}
              />
            </div>
            <div className="section-food-profile-right">
              <div className="section-food-profile-right-top">
                <h3>
                  {t("section_food_list.chef", lang, user?.restaurant)}{" "}
                  {Aa(selectedChef?.firstname) +
                    " " +
                    Aa(selectedChef?.lastname)}
                </h3>
                <div className="section-food-profile-right-top-btn">
                  <span
                    onClick={() => {
                      if (user === null) {
                        return openDialog(true);
                      }
                      if (favoriteLoading) {
                        return;
                      }
                      setFavoriteLoading(true);
                      toggleFavorite();
                    }}
                  >
                    {favoriteLoading && <CircularProgress size={25} />}
                    {!favoriteLoading && (
                      <AiFillHeart
                        color={
                          user !== null && selectedChef?.isFavorited
                            ? "red"
                            : "#000"
                        }
                      />
                    )}{" "}
                    {t("section_food_list.favorite", lang)} (
                    {selectedChef?.favoriteCount || 0})
                  </span>
                  <span
                    onClick={() => {
                      if (user === null) {
                        return openDialog(true);
                      }
                      if (loading) {
                        return;
                      }
                      setLoading(true);
                      followChef();
                    }}
                  >
                    {loading && <CircularProgress size={25} />}
                    {!loading && (
                      <FaUserCircle
                        color={
                          user !== null && selectedChef?.isFollowing
                            ? "red"
                            : "#000"
                        }
                      />
                    )}
                    {t("section_food_list.follow", lang)} (
                    {selectedChef?.followerCount || 0})
                  </span>
                  <span
                    onClick={() => {
                      // Generate referral link
                      const userId = user?._id || "guest";
                      const chefId = selectedChef?._id;
                      const baseUrl = getSafeOrigin();
                      const link = `${baseUrl}/order/chef/menu?chef=${chefId}&ref=${userId}`;
                      setReferralLink(link);
                      setCopied(false);
                      openShareMenu(true);
                    }}
                  >
                    <BsShareFill />
                    {t("section_food_list.share", lang)}
                  </span>
                </div>
              </div>
              <h3 className="iam-from">
                {t("section_food_list.native_from", lang)}{" "}
                {selectedChef?.country}
              </h3>
              {/* {JSON.stringify(reviewList)} */}
              <div className="section-food-bar-details">
                <span>
                  <AiFillStar />
                  {reviewList.length === 0
                    ? t("section_food_list.na", lang)
                    : (
                        reviewList?.reduce((a, b) => a + b?.rate_food.rate, 0) /
                        reviewList.length
                      ).toFixed(2)}
                </span>
                <span>
                  <MdInsertComment />
                  {reviewList.length} {t("section_food_list.comments", lang)}
                </span>
                <span>
                  <MdDeliveryDining />
                  {
                    reviewList?.filter((item) => {
                      return item.status === 3;
                    })?.length
                  }{" "}
                  {t("section_food_list.deliveries", lang)}
                </span>

                {selectedChef?.certificate_safety?.pic !== null && (
                  <span
                    style={{
                      backgroundColor: "#227F21",
                      color: "#fff"
                    }}
                  >
                    {t("section_food_list.food_hygiene_certified", lang)}{" "}
                    <GrValidate
                      style={{
                        backgroundColor: "#fff",
                        borderRadius: 10
                      }}
                    />
                  </span>
                )}
              </div>
              <h3
                className="iam-from"
                style={{
                  marginTop: 10
                }}
              >
                {selectedChef?.bio}
              </h3>
            </div>
          </div>
          <FoodView
            foodList={list
              ?.filter((item) => {
                return item?.chef_id === selectedChef?._id;
              })
              ?.filter((item) => {
                if (searched.length > 0) {
                  return item?.name
                    ?.toLowerCase()
                    .includes(searched.toLowerCase());
                }
                return item;
              })}
            reviewList={reviewList}
            blogList={blogList}
          />
          <div
            style={{
              height: 80
            }}
          ></div>
        </div>
        <div className="section-food-list-right">
          <h3>
            {t("section_food_list.your_order_from", lang)}{" "}
            {Aa(selectedChef?.firstname) + " " + Aa(selectedChef?.lastname)}
          </h3>
          {cart.length === 0 && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <img
                alt="empty-cart"
                src={EmptyCart}
                style={{
                  marginTop: 30,
                  width: 200
                }}
              />
              <p
                style={{
                  marginTop: 20,
                  fontSize: 16,
                  color: "#666",
                  textAlign: "center",
                  padding: "0 20px",
                  lineHeight: "1.4"
                }}
              >
                {t("navbar.empty_cart_message", lang)}
              </p>
            </div>
          )}
          {cart.length > 0 && (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap"
              }}
            >
              <span>
                {t("section_food_list.delivery_on", lang)} {currentDate}
              </span>
              {cart.map((item) => (
                <div className="section-food-list-right-cart-btn">
                  <span
                    className="section-food-list-right-cart-btn-span"
                    onClick={() => {
                      if (
                        cart?.filter((data) => {
                          return data?._id === item?._id;
                        })[0]?.qty <= 1
                      ) {
                        return;
                      }
                      return post_to_cart(
                        [...cart].map((data) => {
                          if (data?._id === item?._id)
                            return { ...data, qty: data.qty - 1 };
                          return { ...data };
                        })
                      );
                    }}
                  >
                    -
                  </span>
                  <span>{item?.qty}</span>
                  <span
                    className="section-food-list-right-cart-btn-span"
                    onClick={() => {
                      if (
                        cart?.filter((data) => {
                          return data?._id === item?._id;
                        })[0]?.qty >= 10
                      ) {
                        return;
                      }
                      return post_to_cart(
                        [...cart].map((data) => {
                          if (data?._id === item?._id)
                            return { ...data, qty: data.qty + 1 };
                          return { ...data };
                        })
                      );
                    }}
                  >
                    +
                  </span>
                  <span
                    style={{
                      fontSize: 15
                    }}
                  >
                    {item?.name?.slice(0, 25) + "..."}
                  </span>
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: 15
                    }}
                  >
                    {"$" + (item?.cost * item?.qty)?.toFixed(2)}
                  </span>
                </div>
              ))}
              <div
                className="btn-see-cart"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 10,
                  width: "95%",
                  height: 50,
                  borderRadius: 25,
                  backgroundColor: "#FF114D",
                  marginTop: 20
                }}
                onClick={() => {
                  if (user === null) {
                    return openDialog(true);
                  }

                  return history.push(
                    `/order/chef/menu/cart?chef=${selectedChef?._id}&date=${selectedWhen}`
                  );
                }}
              >
                <span
                  style={{
                    color: "#fff",
                    fontSize: 15
                  }}
                >
                  {t("section_food_list.see_cart", lang)}{" "}
                </span>
                <span
                  style={{
                    backgroundColor: "#fff",
                    height: 40,
                    width: 80,
                    borderRadius: 20,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: 15,
                    fontWeight: 700
                  }}
                >
                  {"$" +
                    cart?.reduce((a, b) => a + b?.cost * b?.qty, 0)?.toFixed(2)}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
      <Dialog
        open={shareMenu}
        onClose={() => {
          openShareMenu(false);
        }}
      >
        <DialogContent>
          <div
            style={{
              minWidth: 300,
              height: "100%"
            }}
          >
            <div>
              <p
                style={{
                  textAlign: "left",
                  display: "flex",
                  alignItems: "center",
                  gap: 15,
                  fontWeight: 600,
                  marginTop: 30,
                  fontSize: 17
                }}
              >
                {t("common.sharing", lang)}
              </p>
              <p
                style={{
                  textAlign: "left",
                  fontSize: 15,
                  marginBottom: 20
                }}
              >
                {t("common.share_chef_prof", lang, user?.restaurant)}{" "}
              </p>
              <div
                style={{
                  backgroundColor: "#f5f5f5",
                  padding: "15px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "20px"
                }}
              >
                <input
                  type="text"
                  value={referralLink}
                  readOnly
                  style={{
                    flex: 1,
                    border: "none",
                    background: "transparent",
                    outline: "none",
                    fontSize: "14px",
                    color: "#333"
                  }}
                />
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(referralLink);
                    setCopied(true);
                    setTimeout(() => setCopied(false), 2000);
                  }}
                  style={{
                    background: copied ? "#4CAF50" : "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    padding: "10px 20px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    fontSize: "14px",
                    fontWeight: "600",
                    transition: "all 0.3s ease"
                  }}
                >
                  {copied ? <FaCheck /> : <FaCopy />}
                  {copied
                    ? t("common.copied", lang) || "Copied!"
                    : t("common.copy", lang) || "Copy"}
                </button>
              </div>
              <p
                style={{
                  textAlign: "left",
                  fontSize: 13,
                  color: "#666",
                  marginTop: "10px"
                }}
              >
                {t("common.share_link_description", lang) ||
                  "Share this link with your friends to help them discover this amazing chef!"}
              </p>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SectionFoodList;

const post_cart = (data) => ({
  type: POST_TO_CART,
  data: data
});

const post_preferred = (data) => ({
  type: POST_PREFERRED,
  data: data
});

const toggle_dialog = (data) => ({
  type: TOGGLE_DIALOG,
  data: data
});
